module.exports = function () {
    $(document).ready(function () {

        var isError = $('form').find('.has-error').length;

        if (isError) {
            $('form').find('.has-error').closest('.modal').modal('show');
        }

    });
}();